import { ApiError, readJson, type CurrentUser } from "../types"
import { csrfFetch } from "./csrf"
import { mutationRequest } from "./mutationRequest"

const BASE_URL = "/api/v1"

export async function getCurrentUser() {
  const response = await fetch(`${BASE_URL}/auth/me`, {
    credentials: "include",
  })
  if (!response.ok) throw new Error("Not authenticated")
  const { data } = await readJson<CurrentUser>(response)
  return data
}

export async function signIn(
  email: string,
  password: string,
  reactivate = false
) {
  const response = await csrfFetch(`${BASE_URL}/users/sign_in`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user: { email, password, reactivate } }),
  })
  const json = await readJson<CurrentUser>(response)
  if (!response.ok) {
    const error = new ApiError(json.error || "Sign in failed")
    error.code = json.code
    throw error
  }
  return json.data
}

export async function signOut() {
  await mutationRequest(
    `${BASE_URL}/users/sign_out`,
    {
      method: "DELETE",
      credentials: "include",
    },
    "Failed to sign out. Please try again.",
    [401]
  )
}

export async function deactivateAccount() {
  await mutationRequest(
    `${BASE_URL}/account`,
    {
      method: "DELETE",
      credentials: "include",
    },
    "Failed to deactivate account. Please try again."
  )
}

export async function register(
  name: string,
  email: string,
  password: string,
  passwordConfirmation: string
) {
  const response = await csrfFetch(`${BASE_URL}/users`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      user: {
        name,
        email,
        password,
        password_confirmation: passwordConfirmation,
      },
    }),
  })
  const json = await readJson<CurrentUser>(response)
  if (!response.ok)
    throw new Error(
      json.error || (json.errors || []).join(", ") || "Registration failed"
    )
  return json.data
}
